module.exports = __webpack_public_path__ + "images/pro/img-popup-storeagefull@2x-a9d1267c8ab3fe33ce5ec18776eaff98.png";